import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// German
import commonDe from './locales/de/common.json';
import authDe from './locales/de/auth.json';
import ordersDe from './locales/de/orders.json';
import kitchenDe from './locales/de/kitchen.json';
import menuDe from './locales/de/menu.json';
import tablesDe from './locales/de/tables.json';
import dashboardDe from './locales/de/dashboard.json';
import reservationsDe from './locales/de/reservations.json';
import settingsDe from './locales/de/settings.json';
import orderingDe from './locales/de/ordering.json';
import ratingsDe from './locales/de/ratings.json';
import qrcodesDe from './locales/de/qrcodes.json';
import serviceRequestsDe from './locales/de/serviceRequests.json';

// English
import commonEn from './locales/en/common.json';
import authEn from './locales/en/auth.json';
import ordersEn from './locales/en/orders.json';
import kitchenEn from './locales/en/kitchen.json';
import menuEn from './locales/en/menu.json';
import tablesEn from './locales/en/tables.json';
import dashboardEn from './locales/en/dashboard.json';
import reservationsEn from './locales/en/reservations.json';
import settingsEn from './locales/en/settings.json';
import orderingEn from './locales/en/ordering.json';
import ratingsEn from './locales/en/ratings.json';
import qrcodesEn from './locales/en/qrcodes.json';
import serviceRequestsEn from './locales/en/serviceRequests.json';

// French
import commonFr from './locales/fr/common.json';
import authFr from './locales/fr/auth.json';
import ordersFr from './locales/fr/orders.json';
import kitchenFr from './locales/fr/kitchen.json';
import menuFr from './locales/fr/menu.json';
import tablesFr from './locales/fr/tables.json';
import dashboardFr from './locales/fr/dashboard.json';
import reservationsFr from './locales/fr/reservations.json';
import settingsFr from './locales/fr/settings.json';
import orderingFr from './locales/fr/ordering.json';
import ratingsFr from './locales/fr/ratings.json';
import qrcodesFr from './locales/fr/qrcodes.json';
import serviceRequestsFr from './locales/fr/serviceRequests.json';

// Arabic
import commonAr from './locales/ar/common.json';
import authAr from './locales/ar/auth.json';
import ordersAr from './locales/ar/orders.json';
import kitchenAr from './locales/ar/kitchen.json';
import menuAr from './locales/ar/menu.json';
import tablesAr from './locales/ar/tables.json';
import dashboardAr from './locales/ar/dashboard.json';
import reservationsAr from './locales/ar/reservations.json';
import settingsAr from './locales/ar/settings.json';
import orderingAr from './locales/ar/ordering.json';
import ratingsAr from './locales/ar/ratings.json';
import qrcodesAr from './locales/ar/qrcodes.json';
import serviceRequestsAr from './locales/ar/serviceRequests.json';

export { isRtlLanguage, RTL_LANGUAGES } from './rtl';

const ns = [
  'common', 'auth', 'orders', 'kitchen', 'menu', 'tables',
  'dashboard', 'reservations', 'settings', 'ordering',
  'ratings', 'qrcodes', 'serviceRequests',
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: {
        common: commonDe,
        auth: authDe,
        orders: ordersDe,
        kitchen: kitchenDe,
        menu: menuDe,
        tables: tablesDe,
        dashboard: dashboardDe,
        reservations: reservationsDe,
        settings: settingsDe,
        ordering: orderingDe,
        ratings: ratingsDe,
        qrcodes: qrcodesDe,
        serviceRequests: serviceRequestsDe,
      },
      en: {
        common: commonEn,
        auth: authEn,
        orders: ordersEn,
        kitchen: kitchenEn,
        menu: menuEn,
        tables: tablesEn,
        dashboard: dashboardEn,
        reservations: reservationsEn,
        settings: settingsEn,
        ordering: orderingEn,
        ratings: ratingsEn,
        qrcodes: qrcodesEn,
        serviceRequests: serviceRequestsEn,
      },
      fr: {
        common: commonFr,
        auth: authFr,
        orders: ordersFr,
        kitchen: kitchenFr,
        menu: menuFr,
        tables: tablesFr,
        dashboard: dashboardFr,
        reservations: reservationsFr,
        settings: settingsFr,
        ordering: orderingFr,
        ratings: ratingsFr,
        qrcodes: qrcodesFr,
        serviceRequests: serviceRequestsFr,
      },
      ar: {
        common: commonAr,
        auth: authAr,
        orders: ordersAr,
        kitchen: kitchenAr,
        menu: menuAr,
        tables: tablesAr,
        dashboard: dashboardAr,
        reservations: reservationsAr,
        settings: settingsAr,
        ordering: orderingAr,
        ratings: ratingsAr,
        qrcodes: qrcodesAr,
        serviceRequests: serviceRequestsAr,
      },
    },
    lng: localStorage.getItem('i18nextLng') || 'de',
    fallbackLng: 'de',
    supportedLngs: ['de', 'en', 'fr', 'ar'],
    ns,
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
